<div class="ui-control ui-inline-control" [formGroup]="formGroup">
  <span class="input-label">{{inputData.label}} editor</span>
  <quill-editor placeholder="..." [formControlName]="inputData.colName" [style]="{height: '250px'}"></quill-editor>
</div>